export default __webpack_public_path__ + "static/media/icon-edit-blue.02fbfa9e.svg";